module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-secure.ab9d33cb.png";